import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { RootState } from "../../../../store";
import Details from "./Details";
import PaymentKeys from "./payment-keys/PaymentKeys";

const ProfilePage = () => {
  const merchant = useSelector((state: RootState) => state?.merchant?.profile);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    setRole(localStorage.getItem("role"));
  }, []);

  const merchantName = merchant?.merchantName;
  const firstName = merchant?.firstName;
  const lastName = merchant?.lastName;
  const username = merchant?.username;

  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`;

  const merchantPerm = useSelector(
    (state: RootState) => state?.merchant?.permissions
  ) as string[] | undefined;

  const hasPermission = (permission: string): boolean => {
    return Array.isArray(merchantPerm) && merchantPerm.includes(permission);
  };

  const can = hasPermission("CAN_RESET_PAYMENT_SECRETS");

  return (
    <div className="bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        <Details
          initials={initials}
          firstName={firstName}
          lastName={lastName}
          username={username}
          merchantName={merchantName}
          role={role}
        />

        <PaymentKeys />
      </div>
    </div>
  );
};

export default ProfilePage;
